function initPincode() {
  var $inputs = $(".js-pin-entry").not(".pincode-initialized");
  if ($inputs.length) {
    $inputs.pincodeInput({ inputs: 6, characterwidth: 1.25 });
    $inputs.addClass("pincode-initialized");
  }
}

$(document).on("turbo:load", initPincode);
document.addEventListener("DOMContentLoaded", initPincode);
